import { useState } from "react";
import LocalizationInitializer from "./Localization/helpers/LocalizationInitializer";
import App from "./App";

const AppLoader = () => {
  const [ready, setReady] = useState(false);

  return (
    <>
      {!ready && <LocalizationInitializer onReady={() => setReady(true)} />}
      {ready && <App />}
    </>
  );
};

export default AppLoader;